/** Discrete readiness percentage steps (0–150 scale). */
export const READINESS_CIRCLE_STEPS = [
  0, 10, 20, 25, 30, 40, 50, 60, 70, 75, 80, 90, 100, 110, 120, 125, 130, 140, 150,
];

/**
 * Snaps a readiness percentage to the nearest defined step (no interpolation).
 * Values below 0 snap to 0; values above 150 snap to 150.
 * @param {number} value - Raw readiness percentage
 * @returns {number} Nearest step from READINESS_CIRCLE_STEPS
 */
export function snapReadinessValue(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;

  const clamped = Math.max(0, Math.min(150, numeric));

  let nearest = READINESS_CIRCLE_STEPS[0];
  let smallestDiff = Math.abs(clamped - nearest);

  for (let i = 1; i < READINESS_CIRCLE_STEPS.length; i += 1) {
    const step = READINESS_CIRCLE_STEPS[i];
    const diff = Math.abs(clamped - step);
    if (diff < smallestDiff) {
      smallestDiff = diff;
      nearest = step;
    }
  }

  return nearest;
}
